import React, { Component } from 'react';
import './Footer.scss';

export default class Footer extends Component {

  render() {
    return (
      <footer className="footer">
        <div className="main-footer text-center">
          <h4 className="footer-logo">DAVID WILLOUGHBY</h4>
          <div className="social-link">
            <ul>
              <li><a href="https://www.linkedin.com/in/dwilloughby/"><i className="fa fa-linkedin"></i></a></li>
              <li><a href="https://twitter.com/dwilloughby"><i className="fa fa-twitter"></i></a></li>
              <li><a href="https://github.com/wired247"><i className="fa fa-github"></i></a></li>
              <li><a href="https://www.facebook.com/wireddavid"><i className="fa fa-facebook"></i></a></li>
            </ul>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Footer.js